import { format } from "date-fns";
import jsPDF from "jspdf";
// import { Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import NumFormat from "../../helpers/numerico";
// var doc = new jsPDF("p", "mm", "letter");
var doc; //new jsPDF("p", "mm", "letter");
const margenSuperior = 30;
const margenIzquierdo = 20;
function configurarEncabezado(
  oOrganizacion,
  sTitulo,
  sFecha,
  sPaginacion,
  sSucursal,
  sEncabezado
) {
  doc.setDrawColor(0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(oOrganizacion, margenIzquierdo + 1, margenSuperior + 1);
  // doc.line(margenIzquierdo + 20, margenSuperior + 4,); // line, line, bezier curve, line
  //const docWidth = doc.internal.pageSize.getWidth();
  // const docHeight = doc.internal.pageSize.getHeight();
  // linea Punto 1 X,y  Punto 2 x, y
  doc.setLineWidth(1.0);
  doc.line(
    margenIzquierdo + 1,
    margenSuperior + 2,
    margenIzquierdo + 50,
    margenSuperior + 2
  );
  doc.line(70.2, 27, 70.2, 32);
  // console.log(docHeight);
  doc.setFontSize(12);
  doc.text(sTitulo, margenIzquierdo + 60, margenSuperior + 1);
  doc.setFontSize(8);
  doc.text(sFecha, margenIzquierdo + 150, margenSuperior);
  doc.text(sPaginacion, margenIzquierdo + 150, margenSuperior + 4);
  doc.text(sSucursal, margenIzquierdo + 1, margenSuperior + 7);
  doc.setLineWidth(0.5);
  doc.line(margenIzquierdo + 1, margenSuperior + 10, 200, margenSuperior + 10);
  doc.setFontSize(8);
  doc.text(sEncabezado, margenIzquierdo + 1, margenSuperior + 14);
  doc.line(margenIzquierdo + 1, margenSuperior + 16, 200, margenSuperior + 16);
}

async function CrearPdf({ Registros }) {
  doc = new jsPDF("p", "mm", "letter");
  let pdfDt;
  let diferenciaTexto = "";
  let totTextoDif = "Total Diferencia";
  let bTotal = true;
  // console.log(`Valor TipoIf ${Registros[0].TipoInf}`);
  if (Registros[0].TipoInf === "T") {
    diferenciaTexto = "Diferencia(+:Faltan / -:Sob)";
    totTextoDif = "";
    bTotal = false;
  } else if (Registros[0].TipoInf === "S") {
    diferenciaTexto = "Diferencia(Sobran)";
  } else if (Registros[0].TipoInf === "F") {
    diferenciaTexto = "Diferencia(Faltan)";
  }
  try {
    // Configura el encabezado de página

    let posY = margenSuperior + 20;
    let Paginas = 1;
    let bPagina = true;
    let ltotalGeneral = 0;
    Registros.forEach((registro, index) => {
      /************* Encabezado de la página *********************/
      if (bPagina === true) {
        configurarEncabezado(
          Registros[0].NomOrg,
          `Verficación Stk al ${format(
            new Date(Registros[0].Fecha),
            "dd-MM-yyyy"
          )}`,
          `Fecha ${format(new Date(Registros[0].Fecha), "dd-MM-yyyy")}`,
          `Página ${Paginas}`,
          `Sucursal: ${Registros[0].NomSuc} / ${Registros[0].NomBod}`,
          `  Código       Descripción                                       Un             Stock            Stock         ${diferenciaTexto}     ${totTextoDif}       T.General `
        );
        bPagina = false;
      }
      /****************** Fin Encabezado  *********************/

      doc.setFontSize(8);
      doc.text(registro.CodigoFormato, margenIzquierdo + 1, posY);
      const maxAncho = 45;
      const lineas = doc.splitTextToSize(registro.Nombre, maxAncho);
      const numLineas = lineas.length;
      /** Descripcion */
      doc.text(lineas[0], margenIzquierdo + 16, posY);
      /** Unidad */
      doc.text(registro.Unidad, margenIzquierdo + 65, posY);
      /*** stock  */
      doc.text(
        NumFormat.NumeroFormateado(registro.Registrado),
        margenIzquierdo + 85,
        posY,
        { align: "right" }
      );
      doc.text(
        NumFormat.NumeroFormateado(registro.Informado),
        margenIzquierdo + 102,
        posY,
        { align: "right" }
      );
      /*** Diferencias */
      const RtotalesFST = registro.Registrado - registro.Informado;
      const CostoP = registro.TipoInf !== "T" ? registro.CostoPes : 0;
      const Total = RtotalesFST * CostoP;
      ltotalGeneral += Total;
      /*** Totales */
      doc.text(
        NumFormat.NumeroFormateado(RtotalesFST),
        margenIzquierdo + 125,
        posY,
        { align: "right" }
      );

      if (Registros[0].TipoInf !== "T") {
        /*** Costos */
        doc.text(
          NumFormat.NumeroFormateado(CostoP),
          margenIzquierdo + 158,
          posY,
          { align: "right" }
        );
        /*** Total */
        doc.text(
          NumFormat.NumeroFormateado(Total),
          margenIzquierdo + 178,
          posY,
          { align: "right" }
        );
      } else {
        /*** Total */
        doc.text(
          NumFormat.NumeroFormateado(Total),
          margenIzquierdo + 168,
          posY,
          { align: "right" }
        );
      }
      /** Descripcion Aumentando el postY */
      /******   Para el proximo item se aumenta la posicion al final */
      for (let i = 1; i < numLineas; i++) {
        posY = posY + 1 * 3;
        doc.text(lineas[i], margenIzquierdo + 16, posY); // Ajusta el valor 10 según la separación vertical deseada
      }
      /********************************** */
      posY += 5;

      if (posY >= 250 && index < Registros.length - 1) {
        doc.addPage();
        bPagina = true;
        posY = margenSuperior + 20;
        Paginas += 1;
      }
      /********************************** */
    });
    if (bTotal) {
      //Agregar el total
      doc.setLineWidth(0.5);
      doc.line(margenIzquierdo + 1, posY, 200, posY);
      posY += 5;
      doc.text(
        ` Total : ${NumFormat.NumeroFormateado(ltotalGeneral, false)}`,
        margenIzquierdo + 178,
        posY,
        { align: "right" }
      );
    }

    pdfDt = doc.output("blob");
    // Crear una URL para el PDF
    //return pdfDt;
    const pdfUrl = URL.createObjectURL(pdfDt);
    const nuevaVentana = window.open(pdfUrl, "_blank");
    nuevaVentana.focus();
  } catch (error) {
    pdfDt = "Error " + error;
    console.log("Error" + error);
  }
  // setPdfData(pdfDt);
  // Muestra el PDF en pantalla utilizando BlobProvider
  return pdfDt;
}

// var splitRegex = /\r\n|\r|\n/g;
// jsPDF.API.textEx = function (text, x, y, hAlign, vAlign) {
//   console.log("llega aqui");
//   var fontSize = this.internal.getFontSize() / this.internal.scaleFactor;

//   // As defined in jsPDF source code
//   var lineHeightProportion = 1.15;

//   var splittedText = null;
//   var lineCount = 1;
//   if (
//     vAlign === "middle" ||
//     vAlign === "bottom" ||
//     hAlign === "center" ||
//     hAlign === "right"
//   ) {
//     splittedText = typeof text === "string" ? text.split(splitRegex) : text;

//     lineCount = splittedText.length || 1;
//   }

//   // Align the top
//   y += fontSize * (2 - lineHeightProportion);

//   if (vAlign === "middle") y -= (lineCount / 2) * fontSize;
//   else if (vAlign === "bottom") y -= lineCount * fontSize;

//   if (hAlign === "center" || hAlign === "right") {
//     var alignSize = fontSize;
//     if (hAlign === "center") alignSize *= 0.5;

//     if (lineCount > 1) {
//       for (var iLine = 0; iLine < splittedText.length; iLine++) {
//         this.text(
//           splittedText[iLine],
//           x - this.getStringUnitWidth(splittedText[iLine]) * alignSize,
//           y
//         );
//         y += fontSize * lineHeightProportion;
//       }
//       return this;
//     }
//     x -= this.getStringUnitWidth(text) * alignSize;
//   }

//   this.text(text, x, y);
//   return this;
// };

export default CrearPdf;
